const opts: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
};

/** Formats ISO 8061 date using browser's locale. */
export const i18nShortDate = (
  isoDate: string,
  locale: string = navigator.language,
): string => new Date(isoDate).toLocaleDateString(locale, opts);
